module.exports = __webpack_public_path__ + "img/signup.1f9208be.png";